export default {
  name: 'refundRecord',
  data() {
    return {
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      totalRows: 100,
      labelPosition: 'right',
      formInline: {
        system: [],
        sysId: '',
        virtualSellerCode: '',
        payChannelCode: '',
        sellerTradeNo: '',
        tradeNo: '',
        payTime: '',
        outTradeNo: '',
        refundStatus: ''
      },
      tooltip: true,
      sysData: [],
      merchantData: [],
      payChannelData: [],
      tableList: [],
      dialogFormVisible: false,
      payDetailForm: [],
      /* 退款状态 */
      refundStatusData: [
        {
          id: 0,
          value: '退款处理中'
        },
        {
          id: 1,
          value: '退款成功'
        },
        {
          id: 2,
          value: '退款失败'
        }
      ],
      payDetailTableData: []
    }
  },
  created() {
    this.querySearchSel()
    this.queryList()
  },
  methods: {
    /* 表格状态值转换 */
    refundStatus(row) {
      if (row.refundStatus == '0') {
        return '退款处理中'
      } else if (row.refundStatus == '1') {
        return '退款成功'
      } else if (row.refundStatus == '2') {
        return '退款失败'
      } else {
        return ''
      }
    },
    /* 弹窗状态值转换 */
    refundStatusToText(type) {
      switch (parseInt(type)) {
        case 0:
          type = '退款处理中'
          break
        case 1:
          type = '退款成功'
          break
        case 2:
          type = '退款失败'
          break
        default:
          type = ''
      }
      return type
    },
    querySearchSel() {
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      let _self = this
      /* 查询所属系统列表 */
      this.$axios
        .post(this.$API.apiList.querySysList, params)
        .then(function(r) {
          _self.sysData = r.data.resData
        })
        .catch(function(error) {})
      /* 查询商户名称列表 */
      this.$axios
        .get(this.$API.pay.queryVirtualSellerList, {})
        .then(function(r) {
          _self.merchantData = r.data.resData.sellerList
        })
        .catch(function(error) {})
      /* 查询支付渠道列表 */
      this.$axios
        .get(this.$API.pay.queryPayChannelList, {})
        .then(function(r) {
          _self.payChannelData = r.data.resData.channelList
        })
        .catch(function(error) {})
    },
    queryList() {
      /* 查询列表 */
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.sizeSmall,
        sysIds: sysIds, //系统id
        virtualSellerCode: this.formInline.virtualSellerCode,
        refundChannelCode: this.formInline.payChannelCode, //渠道编号，不选定渠道是不传该参数
        serviceTradeNo: this.formInline.sellerTradeNo.trim(), //业务订单号
        outTradeNo: this.formInline.outTradeNo.trim(), //支付订单号
        tradeNo: this.formInline.tradeNo.trim(), //支付流水号
        refundStatus: this.formInline.refundStatus, //退款状态(0退款处理中1退款成功2退款失败)
        refundStartTime: this.formInline.payTime
          ? this.formInline.payTime[0]
          : '', //退款开始时间
        refundEndTime: this.formInline.payTime ? this.formInline.payTime[1] : '' //退款结束时间
      }
      let _self = this
      this.$axios
        .post(this.$API.pay.queryRefundRecordListByPage,params)
        .then(function(r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function(error) {})
    },
    /* 点击查询按钮 */
    onSearch() {
      this.page.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset(formName) {
      this.formInline.sysId = ''
      this.formInline.virtualSellerCode = ''
      this.formInline.payChannelCode = ''
      this.formInline.sellerTradeNo = ''
      this.formInline.outTradeNo = ''
      this.formInline.tradeNo = ''
      this.formInline.refundStatus = ''
      this.formInline.payTime = ''
      this.formInline = Object.assign({}, this.formInline)
      // this.$refs[formName].resetFields()
    },
    /* 查看详情 */
    showDetail(data) {
      this.dialogFormVisible = true
      let _self = this
      let params = {
        refundId: data.refundId
      }
      this.$axios
        .get(this.$API.pay.queryRefundRecordById, {params: params})
        .then(function(r) {
          _self.payDetailForm = r.data.resData
          let _tableData = r.data.resData.orderInfo ? JSON.parse(r.data.resData.orderInfo) : []
          if (_tableData.prodInfo.length) { 
            _self.payDetailTableData = _tableData.prodInfo
          }
        })
        .catch(function(error) {})
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          // 只计算总金额列
          if (index === 4) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index]
          }
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    downBill () { // 账单下载
      let op = {}
      op.refundStartTime = this.formInline.payTime ? this.formInline.payTime[0] : ''
      op.refundEndTime = this.formInline.payTime ? this.formInline.payTime[1] : ''
      op.virtualSellerCode = this.formInline.virtualSellerCode
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.sysIds = sysIds
      op.refundChannelCode = this.formInline.payChannelCode
      op.serviceTradeNo = this.formInline.sellerTradeNo
      op.outTradeNo = this.formInline.outTradeNo
      op.tradeNo = this.formInline.tradeNo
      op.refundStatus = this.formInline.refundStatus
      if (!sysIds.length) {
        this.$message.error('请选择订单所属系统')
        return
      }
      if (!op.refundChannelCode) {
        this.$message.error('请选择退款渠道')
        return
      }
      if (!op.refundStartTime) {
        this.$message.error('请选择退款时间')
        return
      }
      if (!op.refundEndTime) {
        this.$message.error('请选择退款时间')
        return
      }
      let url = this.$API.billmanagement.downloadRefundRecord
      // let url = 'http://172.16.9.104:5010/agw/refundCtr/downloadRefundRecord'
      let params = { // 参数
        sysIds: op.sysIds,
        virtualSellerCode: op.virtualSellerCode,
        refundChannelCode: op.refundChannelCode,
        serviceTradeNo: op.serviceTradeNo,
        outTradeNo: op.outTradeNo,
        tradeNo: op.tradeNo,
        refundStatus: op.refundStatus,
        refundStartTime: op.refundStartTime,
        refundEndTime: op.refundEndTime,
        mtk: localStorage.getItem('usermtk')
      }
      let form = document.createElement('form')
      form.id = 'form'
      form.name = 'form'
      document.body.appendChild(form)
      for (let obj in params) {
        if (params.hasOwnProperty(obj)) {
          var input = document.createElement('input')
          input.tpye = 'hidden'
          input.name = obj
          input.value = params[obj]
          form.appendChild(input)
        }
      }
      form.method = 'POST' // 请求方式
      form.action = url
      form.submit()
      document.body.removeChild(form)
    },
    // 每页显示多少条
    pageSizeChange(val) {
      this.page.sizeSmall = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange(val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/refund/refundRecord.js